import { render, staticRenderFns } from "./QRCard.vue?vue&type=template&id=2d6a49f0&"
import script from "./QRCard.vue?vue&type=script&lang=js&"
export * from "./QRCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports